export default __webpack_public_path__ + "static/media/pessoas.3d43d0b0.svg";